import {
    ChangeDetectionStrategy,
    Component,
    Input,
    OnChanges,
    OnInit,
    ViewEncapsulation,
} from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';

import { OrderAddressInfo } from '../../../../models/orders-type.model';
import { ItemOrderService } from '../../item-order.service';

import { Order } from '@api/order/order.models';
import { getCmsConfigValue } from '@core/infrastructure/state/core.selectors';

type OrderStatus = 'canceled' | 'confirmed' | 'courier' | 'delivered' | 'dispatch' | 'preparation';
@Component({
    selector: 'order-tracking',
    templateUrl: './order-tracking.component.html',
    styleUrls: ['./order-tracking.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    // eslint-disable-next-line @angular-eslint/use-component-view-encapsulation
    encapsulation: ViewEncapsulation.None,
})
export class OrderTrackingComponent implements OnInit, OnChanges {
    @Input() public order: Order;

    @Input() public orderAddress: OrderAddressInfo;

    @Input() private readonly selectedSuborder: number | string;

    public deliveryDate$: Observable<string>;

    public courier: any;

    public urlTracking: any;

    public trackingNumber: any;

    public shippingKind: string;

    public orderStatusUpdated: Record<OrderStatus, any>;

    public orderCurrentStatus: Record<OrderStatus, boolean>;

    public showTracking: boolean;

    public hideDeliveryDates$: Observable<boolean> = this.store.select(getCmsConfigValue('hide_delivery_dates'));

    constructor(
        private readonly store: Store,
        private readonly itemOrderService: ItemOrderService,
    ) {}

    public ngOnInit() {
        this.initTacking();
    }

    private initTacking() {
        this.showTracking = (this.courier || this.trackingNumber)
            && this.orderCurrentStatus.courier
            && !this.orderCurrentStatus.delivered
            && (!this.orderCurrentStatus.dispatch || this.orderCurrentStatus.dispatch && this.shippingKind === 'delivery');

        this.deliveryDate$ = this.itemOrderService.getDeliveryDate(this.order, this.selectedSuborder).pipe(shareReplay(1));

        const orderTrackingSelected = this.itemOrderService.getOrderTrackingSelected(this.order) || {};

        this.courier = orderTrackingSelected.courier || this.order.courier;
        this.urlTracking = orderTrackingSelected.urlTracking || orderTrackingSelected.urlTrackingCIS;
        this.trackingNumber = orderTrackingSelected.trackingNumber;

        this.orderStatusUpdated = this.getOrderStatusUpdated(this.order);

        this.shippingKind = this.itemOrderService.getShippingKind(this.order.shipping.kind);
        this.orderCurrentStatus = this.itemOrderService.getOrderStatus(this.order);
    }

    private getOrderStatusUpdated(order) {
        let orderStatusUpdated = {
            confirmed: null,
            preparation: null,
            courier: null,
            dispatch: null,
            delivered: null,
            canceled: null,
        };

        if (Object.keys(order.orderTracking)[0]) {
            order.orderTracking[Object.keys(order.orderTracking)[0]].statusTracking.forEach((statusTack: any) => {
                const updateDate = statusTack.fechaActualizacion.replace(' ', 'T');
                switch (statusTack.subStatus) {
                    case '01':
                    case '1':
                        orderStatusUpdated.courier = updateDate;
                        break;
                    case '02':
                    case '2':
                        orderStatusUpdated.delivered = updateDate;
                        break;
                    case '08':
                    case '8':
                    case '10':
                    case '100':
                        orderStatusUpdated.dispatch = updateDate;
                        break;
                    case '101':
                        orderStatusUpdated.preparation = updateDate;
                        break;
                    case '102':
                        orderStatusUpdated.canceled = updateDate;
                        break;
                }
            });
        }

        return orderStatusUpdated;
    }

    public ngOnChanges(): void {
        this.deliveryDate$ = this.itemOrderService.getDeliveryDate(this.order, this.selectedSuborder).pipe(shareReplay(1));
    }
}
